import axios from "axios";

// Use REACT_APP_BACKEND_URL when provided (absolute URL).
// Fall back to relative "/api" so the app also works on any custom domain
// (e.g. https://eneaspecialist.it) where the K8s ingress routes /api → backend.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});
